export default __webpack_public_path__ + "static/media/bank_accounts_page.7071f8ad.pdf";